import React from 'react';
import { Link } from 'react-router-dom';
import type { InlineText } from '../../legal/types';

/**
 * The inline grammar of legal InlineText (src/legal/types.ts):
 *   **bold**, [label](href), bare email addresses, and "\n" line breaks.
 * Anything else is rendered as-is, so a verbatim port stays verbatim.
 */
const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|[\w.+-]+@[\w-]+(?:\.[\w-]+)+|\n)/g;

export function renderInline(text: InlineText): React.ReactNode[] {
  const parts = text.split(TOKEN);
  return parts.map((part, index) => {
    if (!part) return null;
    if (part === '\n') return <br key={index} />;
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      const [, label, href] = link;
      if (href.startsWith('/')) {
        return (
          <Link key={index} to={href}>
            {label}
          </Link>
        );
      }
      return (
        <a key={index} href={href} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      );
    }
    if (/^[\w.+-]+@[\w-]+(?:\.[\w-]+)+$/.test(part)) {
      return (
        <a key={index} href={`mailto:${part}`}>
          {part}
        </a>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}
